module.exports = __webpack_public_path__ + "static/media/cat7.e97ff2d3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat7.jpeg
// module id = 39
// module chunks = 0